import DocIcon from './doc';
import DocxIcon from './docx';
import GifIcon from './gif';
import HtmlIcon from './html';
import JpgIcon from './jpg';
import MdIcon from './md';
import Mp4Icon from './mp4';
import PdfIcon from './pdf';
import PngIcon from './png';
import PptIcon from './ppt';
import PptxIcon from './pptx';
import RarIcon from './rar';
import SvgIcon from './svg';
import TxtIcon from './txt';
import UnknowIcon from './unknow';
import XlsIcon from './xls';
import XlsxIcon from './xlsx';
import ZipIcon from './zip';

export default {
  "doc":DocIcon,
  "docx":DocxIcon,
  "gif":GifIcon,
  "html":HtmlIcon,
  "jpg":JpgIcon,
  "md":MdIcon,
  "mp4":Mp4Icon,
  "pdf":PdfIcon,
  "png":PngIcon,
  "ppt":PptIcon,
  "pptx":PptxIcon,
  "rar":RarIcon,
  "svg":SvgIcon,
  "txt":TxtIcon,
  "unknow":UnknowIcon,
  "xls":XlsIcon,
  "xlsx":XlsxIcon,
  "zip":ZipIcon
  };